var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1111,
    height: 392,
    viewBox: "0 0 1111 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H185C284.433 0 366.573 74.0427 379.291 170H395V41L776.728 41C811.583 41 845.78 50.4949 875.646 68.465C884.534 73.8129 893.841 78.4311 903.476 82.2744L934.059 94.4742C964.739 106.713 997.469 113 1030.5 113L1030.52 113.037C1075.19 114.367 1111 151.002 1111 196C1111 240.998 1075.19 277.633 1030.52 278.963L1030.5 279C997.478 279 964.766 285.379 934.163 297.785L901.526 311.016C892.522 314.667 883.807 318.994 875.456 323.962C845.704 341.659 811.728 351 777.11 351H395V222H379.291C366.573 317.957 284.433 392 185 392H0V0Z",
    fill: "#2D2F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433 65H508V78H433V137H470V150H433H420V137V78V65H433Z",
    fill: "#343744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526 65H601H614V78V105H601L601 78H526V65Z",
    fill: "#343744"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632 65H707H720V78V105H707L707 78H632V65Z",
    fill: "#343744"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720 327L645 327L632 327L632 314L632 287L645 287L645 314L720 314L720 327Z",
    fill: "#343744"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614 327L539 327L526 327L526 314L526 287L539 287L539 314L614 314L614 327Z",
    fill: "#343744"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433 327H508V314H433L433 255H470V242H433H420V255V314V327H433Z",
    fill: "#343744"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 231,
    width: 70,
    height: 243,
    rx: 35,
    transform: "rotate(-90 544 231)",
    fill: "#343744"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 392,
    fill: "#343744"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    width: 8,
    height: 392,
    fill: "#2D2F3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M848 299L848 92",
    stroke: "#343744",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M856 296L856 96",
    stroke: "#343744",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M864 296L864 100",
    stroke: "#343744",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M872 293L872 103",
    stroke: "#343744",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M880 290L880 106",
    stroke: "#343744",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M888 288L888 108",
    stroke: "#343744",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M896 287L896 109",
    stroke: "#343744",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M904 286L904 110",
    stroke: "#343744",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M912 285L912 111",
    stroke: "#343744",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M920 284L920 112",
    stroke: "#343744",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M928 283L928 113",
    stroke: "#343744",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M936 282L936 114",
    stroke: "#343744",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M944 281L944 115",
    stroke: "#343744",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M952 281L952 115",
    stroke: "#343744",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M960 281L960 115",
    stroke: "#343744",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M840 301L840 90",
    stroke: "#343744",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M832 305L832 86",
    stroke: "#343744",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M824 310L824 81",
    stroke: "#343744",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M816 315L816 76",
    stroke: "#343744",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M808 320L808 71",
    stroke: "#343744",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M138 273H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M138 279H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M138 285H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M138 291H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M138 297H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M138 303H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M138 309H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138 315H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M138 321H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M138 327H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M138 333H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M138 339H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M138 345H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M138 351H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M138 357H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M138 363H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M138 369H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M138 375H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M138 381H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M138 387H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M138 6H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M138 12H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M138 18H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M138 24H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M138 30H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M138 36H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M138 42H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M138 48H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M138 54H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M138 60H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M138 66H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138 72H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M138 78H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138 84H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M138 90H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M138 96H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M138 102H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M138 108H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M138 114H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M779 41L821.045 65.6068C864.563 91.0759 914.077 104.5 964.5 104.5V104.5L896.138 69.3505C859.903 50.7191 819.745 41 779 41V41Z",
    fill: "#343744"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M779 350.5L821.045 325.893C864.563 300.424 914.077 287 964.5 287V287L896.138 322.149C859.903 340.781 819.745 350.5 779 350.5V350.5Z",
    fill: "#343744"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 391.997C184.333 391.999 184.666 392 185 392C284.778 392 367.143 317.442 379.421 221H355.196C343.09 304.144 271.502 368 185 368C184.666 368 184.333 367.999 184 367.997V391.997ZM184 344.997C184.333 344.999 184.666 345 185 345C258.771 345 320.021 291.388 331.912 221H307.5C295.918 278.056 245.474 321 185 321C184.666 321 184.333 320.999 184 320.996V344.997ZM184 71.0039V47.0033C184.333 47.0011 184.666 47 185 47C258.071 47 318.857 99.5991 331.56 169H307.076C294.734 112.943 244.765 71 185 71C184.666 71 184.333 71.0013 184 71.0039ZM184 295.995C184.333 295.998 184.666 296 185 296C231.596 296 270.748 264.131 281.85 221H256.792C246.454 250.692 218.215 272 185 272C184.666 272 184.333 271.998 184 271.994V295.995ZM184 120.006V96.0049C184.333 96.0016 184.666 96 185 96C230.873 96 269.531 126.888 281.312 169H256.064C245.175 140.356 217.465 120 185 120C184.666 120 184.333 120.002 184 120.006ZM184 24.0028V0.00249727C184.333 0.000833078 184.666 0 185 0C284.087 0 366.001 73.5287 379.156 169H354.893C341.938 86.8337 270.807 24 185 24C184.666 24 184.333 24.0009 184 24.0028Z",
    fill: "#343744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.02304e713675d3f88e1833bb6f32aac7.svg";
export { ForwardRef as ReactComponent };